<script>
  import { Title, Content } from '@smui/paper';
  import Button, { Label, Icon } from '@smui/button';
  import Checkbox from '@smui/checkbox';
  import FormField from '@smui/form-field';
  import { createEventDispatcher } from 'svelte';
  import { pluralise } from '$lib/client/utils/typography';
  import { DateTime } from 'luxon';

  export let ask;

  const artist = ask.context;
  const dispatch = createEventDispatcher();
  const plural = pluralise(artist.name);
</script>

{#if ask.metadata?.starts_at}
  <div class="mdc-typography--subtitle1 t-uppercase u-pb-tiny">
    {DateTime.fromJSDate(ask.metadata.starts_at).toLocaleString(DateTime.DATETIME_FULL)}
  </div>
{/if}

<Title>{ask.title ? ask.title : `${plural} want you to visit this link`}</Title>
<Content>
  <p>{ask.content}</p>

  {#if ask.metadata?.lineup}
    <ol class="u-p-none">
      {#each ask.metadata?.lineup as artist_link, index}
        <li>
          <span class="mdc-typography--headline{index === 0 ? 4 : 5} t-uppercase">
            {#if artist_link.slug}
              <a class="link link--secondary" href="/artists/{artist_link.slug}">{artist_link.name}</a>
            {:else}
              {artist_link.name}
            {/if}
          </span>
        </li>
      {/each}
    </ol>
  {/if}

  <nav class="actions b--secondary b--solid-t-tiny u-mt u-pt">
    <slot name="actions" />

    <Button
      class="complete-ask"
      color="primary"
      variant="raised"
        tag="a"
      href={ask.metadata?.url}
      target="_blank"
      rel="noopener"
      on:click={() => dispatch('completed')}
    >
      <Label>Get Tickets</Label>
      <Icon class="material-icons">navigate_next</Icon></Button
    >
  </nav>
</Content>
